export default __webpack_public_path__ + "static/smellsLikeCola-150d3d9ef28bf32cb35e5706212f9cdb.png";